import {BaseEntity} from "./BaseEntity";

export class CheckoutHistory implements BaseEntity {
    constructor(
        public id?:number,
        public checkinStatus?:string,
        public individual?:string,
        public assetName?: string,
        public locationName?: string,
        public transactionTime?:string,
        public assetID?: string,
        public locationID?: string    ) {
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.checkinStatus = json.checkinStatus;
        this.individual = json.individual;
        this.assetName = json.assetName;
        this.locationName = json.locationName;
        this.transactionTime = json.transactionTime;
        this.assetID = json.assetID;
        this.locationID = json.locationID;
    }
}
